// extracted by mini-css-extract-plugin
export var boxItems = "_9o-1";
export var boxItemsLg = "_9o-2";
export var button = "_9o-7";
export var buttonHoverless = "_9o-9";
export var buttonLg = "_9o-8";
export var filterGroupBox = "_9o-0";
export var icon = "_9o-3";
export var iconSecondary = "_9o-6";
export var iconWrapper = "_9o-4";
export var iconWrapperLg = "_9o-5";
export var truncatedLabel = "_9o-a";